/*
 * Delivery page copy and sample board data.
 *
 * Page copy (hero, principles, board labels, a11y text, Definition of Done
 * prose) lives in enterpriseMessaging.js as DELIVERY_* constants, applied from
 * household-tracker PR #18 at ab75373. This file holds the synthetic board data.
 *
 * Board data is illustrative and synthetic. "Sample Analytics Co." is a
 * fictitious company; no client backlog or live board is shown.
 */

export const DELIVERY_SAMPLE_BOARD = {
  badge: 'Illustrative, synthetic data',
  company: 'Sample Analytics Co.',
  title: 'Sample Analytics Co., Sprint 14',
  caption:
    'Columns are stages. Rows are features. Each card shows its ID, type, owner initials, and story points.',
  rowHeader: 'Feature',
  rows: [
    { key: 'c360', label: 'Customer 360 view', goal: 'Goal 1 · Trusted customer data' },
    { key: 'rev', label: 'Revenue reporting', goal: 'Goal 2 · Finance analytics' },
    { key: 'ai', label: 'Churn risk model', goal: 'Goal 3 · AI insights' },
  ],
  types: [
    { key: 'story', label: 'User story', className: 'border-l-brand-600 bg-brand-50' },
    { key: 'task', label: 'Task', className: 'border-l-emerald-600 bg-emerald-50' },
    { key: 'bug', label: 'Bug', className: 'border-l-rose-600 bg-rose-50' },
  ],
  cards: [
    { id: 'SAC-142', row: 'c360', state: 'Backlog', type: 'story', title: 'Merge duplicate customer records', owner: 'DS', points: 5 },
    { id: 'SAC-131', row: 'rev', state: 'In Grooming', type: 'story', title: 'Define net revenue by region', owner: 'JL', points: 3 },
    { id: 'SAC-128', row: 'ai', state: 'Prioritized', type: 'task', title: 'Profile 24 months of usage data', owner: 'PK', points: 2 },
    { id: 'SAC-117', row: 'c360', state: 'Development', type: 'story', title: 'Trusted customer view with key attributes', owner: 'AM', points: 8, active: true },
    { id: 'SAC-121', row: 'ai', state: 'Development', type: 'task', title: 'Feature pipeline for churn signals', owner: 'PK', points: 5 },
    { id: 'SAC-109', row: 'rev', state: 'QA', type: 'bug', title: 'Fix currency rounding on totals', owner: 'RT', points: 1 },
    { id: 'SAC-104', row: 'c360', state: 'UAT', type: 'story', title: 'Account owner lookup', owner: 'AM', points: 3 },
    { id: 'SAC-098', row: 'rev', state: 'Pre-Production', type: 'story', title: 'Monthly revenue dashboard', owner: 'JL', points: 5 },
    { id: 'SAC-091', row: 'ai', state: 'Released', type: 'story', title: 'Baseline churn score, v1', owner: 'PK', points: 8 },
    { id: 'SAC-085', row: 'c360', state: 'Closed', type: 'task', title: 'Source system access approved', owner: 'RT', points: 1 },
    { id: 'SAC-079', row: 'rev', state: 'Closed', type: 'story', title: 'Revenue data model in Snowflake', owner: 'JL', points: 5 },
  ],
};
